import{useTreatment as t}from"@splitsoftware/splitio-react";import{OnOffTreatmentsEnum as r}from"../../types.js";function o(o){const{treatment:e}=t({name:o});return e===r.On}export{o as useSplitIoFeatureFlag};
